import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';
import { installRegisterRequestSafety } from './utils/registerSession';
import { UserProvider } from './UserContext';

import { BrandingProvider } from './BrandingContext';

import { LicenseInfo } from '@mui/x-data-grid-pro';
LicenseInfo.setLicenseKey(process.env.REACT_APP_XGRID_LICENSE_KEY);

installRegisterRequestSafety(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <UserProvider>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </UserProvider>
  </React.StrictMode>
);
